import React from 'react';

import ShareInformationContainer from '@/company/IR/containers/ShareInformationContainer';
import IRLayout from '@/company/IR/Layout/IRLayout';
import SEOTitle from '@/components/SeoTitle';

export default function ShareInformation({ pageSEOMetaData }) {
  return (
    <>
      <SEOTitle pageSEOMetaData={pageSEOMetaData} />
      <IRLayout>
        <ShareInformationContainer />
      </IRLayout>
    </>
  );
}

/**
 * Runs on server side & client side
 */
ShareInformation.getInitialProps = async ({ store }) => {
  const pageSEOMetaData = store.appStore.config.getPageSEOMetaData('ir');

  return {
    pageSEOMetaData,
  };
};
